// Upload do COMPROVANTE DE MATRÍCULA (opcional) no checkout da carteirinha.
//
// Aceita imagem OU PDF e guarda como data URL base64 em `dados.comprovante`. O
// backend (aprovacaoPagamento.criarCarteirinhaDigital) grava esse valor em
// carteirinhas_comprovante_matricula quando a carteirinha digital é criada.
//
// Auto-contido (CSS próprio) pra servir tanto o /produtos quanto o cadastro.
import { useState } from 'react';
import { Upload, FileText, X } from 'lucide-react';
import { Field } from './Fields';
import './ComprovanteUpload.css';

const MAX_MB = 5;

export default function ComprovanteUpload({ valor, onChange, onErro }) {
    const [nomeArquivo, setNomeArquivo] = useState('');
    const aviso = onErro || (() => {});
    const ehImagem = typeof valor === 'string' && valor.startsWith('data:image');
    const temArquivo = !!valor;

    const onArquivo = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const ok = file.type.startsWith('image/') || file.type === 'application/pdf';
        if (!ok) return aviso('Envie uma imagem (JPG/PNG) ou um PDF.');
        if (file.size > MAX_MB * 1024 * 1024) return aviso(`O comprovante deve ter no máximo ${MAX_MB} MB.`);
        const reader = new FileReader();
        reader.onload = () => { setNomeArquivo(file.name); onChange(reader.result); };
        reader.readAsDataURL(file);
    };

    const remover = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setNomeArquivo('');
        onChange('');
    };

    return (
        <Field label="Comprovante de matrícula">
            <label className="ueb-comp">
                {!temArquivo ? (
                    <span className="ueb-comp-ph"><Upload size={18} /> Enviar comprovante (imagem ou PDF)</span>
                ) : ehImagem ? (
                    <span className="ueb-comp-preview">
                        <img src={valor} alt="Prévia do comprovante" />
                        <button type="button" className="ueb-comp-x" onClick={remover} aria-label="Remover comprovante"><X size={15} /></button>
                    </span>
                ) : (
                    <span className="ueb-comp-file">
                        <FileText size={18} />
                        <span className="ueb-comp-file-nome">{nomeArquivo || 'Comprovante anexado (PDF)'}</span>
                        <button type="button" className="ueb-comp-x" onClick={remover} aria-label="Remover comprovante"><X size={15} /></button>
                    </span>
                )}
                <input type="file" accept="image/*,application/pdf" onChange={onArquivo} hidden />
            </label>
        </Field>
    );
}
